import Skeleton from "@mui/material/Skeleton";

const PdfSkeleton = () => (
  <div className="w-full h-full flex flex-col">
    <Skeleton variant="rectangular" width="100%" height={40} className="mb-2" />
    <Skeleton
      variant="rectangular"
      width="100%"
      height="100%"
      className="flex-1"
    />
  </div>
);

export default PdfSkeleton;
